import { render, staticRenderFns } from "./KgjtWebsiteAnnouncementEdit.vue?vue&type=template&id=317df45c&scoped=true&"
import script from "./KgjtWebsiteAnnouncementEdit.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteAnnouncementEdit.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteAnnouncementEdit.vue?vue&type=style&index=0&id=317df45c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317df45c",
  null
  
)

export default component.exports